import { UAParser } from 'ua-parser-js';

export enum OsType {
  Android = 'Android',
  IOS = 'iOS',
}

export enum ClientType {
  DirittoAppIos = 'DirittoAppIos',
  DirittoAppAos = 'DirittoAppAos',
  Chrome = 'Chrome',
  Safari = 'Safari',
  Firefox = 'Firefox',
  Unknown = 'Unknown',
}

export type UseClientType = {
  os: string;
  isApp: boolean;
  isMobileDevice: boolean;
  isIosApp: boolean;
  isAosApp: boolean;
  isWeb: boolean;
  isIosWeb: boolean;
  isAosWeb: boolean;
  version: string;
  clientType: ClientType;
};

/**
 * Possible 'os.name'
 * AIX, Amiga OS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, Chromium OS, Contiki,
 * Fedora, Firefox OS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS,
 * Joli, Linpus, Linux, Mac OS, Mageia, Mandriva, MeeGo, Minix, Mint, Morph OS, NetBSD,
 * Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
 * RIM Tablet OS, RISC OS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
 * Ubuntu, UNIX, VectorLinux, WebOS, Windows [Phone/Mobile], Zenwalk
 */

// Android Diritto app
// {Webview UserAgent} Diritto/{version}
// Mozilla/5.0 (Linux; Android 7.0; SM-N920S Build/NRD90M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/3.0 Chrome/80.0.3987.119 Mobile Safari/537.36 Diritto/1.0.3
export const parseUserAgent = (userAgent: string): UseClientType => {
  const dirittoAppBrowsers = [[/(Diritto)\/([\w.]+)/i], [UAParser.BROWSER.NAME, UAParser.BROWSER.VERSION]];
  const parser = new UAParser(userAgent, { browser: dirittoAppBrowsers });

  const os = parser.getOS().name;
  const browser = parser.getBrowser().name;
  const { type: deviceType } = parser.getDevice();

  let clientType = ClientType.Unknown;
  switch (browser) {
    case 'Chrome':
      clientType = ClientType.Chrome;
      break;
    case 'Safari':
      clientType = ClientType.Safari;
      break;
    case 'Firefox':
      clientType = ClientType.Firefox;
      break;
    case 'Diritto':
      // Diritto App 은 iOS 아니면 Android 이다.
      clientType = os === 'iOS' ? ClientType.DirittoAppIos : ClientType.DirittoAppAos;
      break;
    default:
      clientType = ClientType.Unknown;
  }

  const isMobileDevice = deviceType === 'mobile' || deviceType === 'tablet';
  const isWeb = clientType !== ClientType.DirittoAppAos && clientType !== ClientType.DirittoAppIos;
  return {
    os: os ?? '',
    isWeb,
    isMobileDevice,
    isIosWeb: os === OsType.IOS && isWeb,
    isAosWeb: os === OsType.Android && isWeb,
    isApp: !isWeb,
    isIosApp: clientType === ClientType.DirittoAppIos,
    isAosApp: clientType === ClientType.DirittoAppAos,
    version: parser.getBrowser().version || '',
    clientType,
  };
};
